/**
 * SupportApiService - Support Ticket Service
 *
 * Handles creation of support tickets.
 *
 * Migration Status: SDK enabled
 * - Wrapper: SupportSDKWrapper
 */

import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import { SupportSDKWrapper } from 'src/sdk/api/wrapper/SupportSDKWrapper';

export default class SupportApiService extends AbstractApiService {
  protected useSdk = true;
  protected sdkWrapper = new SupportSDKWrapper();

  public constructor() {
    super({});
  }

  /**
   * Create a support ticket
   *
   * @param formData - Form data containing ticket information
   * @returns Promise resolving to ticket creation result
   */
  public async create_ticket(formData: any): Promise<any> {
    if (this.useSdk && this.sdkWrapper) {
      return this.sdkWrapper.createTicket(formData);
    }

    return super.post(api.create_support_ticket, formData);
  }
}
